import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin requests need cookies for auth
const withAuth = { withCredentials: true };

export const api = {
  createSubmission: (payload) => axios.post(`${API}/submissions`, payload),
  getPartial: (id) => axios.get(`${API}/submissions/${id}/partial`),
  captureEmail: (id, email) => axios.post(`${API}/submissions/${id}/email`, { email }),
  getResult: (token) => axios.get(`${API}/results/${token}`),
  getPublicConfig: () => axios.get(`${API}/config/public`),

  adminLogin: (password) => axios.post(`${API}/admin/login`, { password }, withAuth),
  adminLogout: () => axios.post(`${API}/admin/logout`, {}, withAuth),
  adminMe: () => axios.get(`${API}/admin/me`, withAuth),
  adminList: (view) =>
    axios.get(`${API}/admin/submissions`, {
      ...withAuth,
      params: view ? { view } : {},
    }),
  adminGet: (id) => axios.get(`${API}/admin/submissions/${id}`, withAuth),
  adminUpdate: (id, payload) => axios.patch(`${API}/admin/submissions/${id}`, payload, withAuth),
  adminSetAdminStatus: (id, adminStatus) =>
    axios.patch(`${API}/admin/submissions/${id}/admin-status`, { adminStatus }, withAuth),
  adminSetStar: (id, starred) =>
    axios.patch(`${API}/admin/submissions/${id}/star`, { starred }, withAuth),
  adminGenerate: (id) => axios.post(`${API}/admin/submissions/${id}/generate`, {}, withAuth),
  adminSaveResult: (id, fullResult) =>
    axios.put(`${API}/admin/submissions/${id}/result`, { fullResult }, withAuth),
  adminRevertResult: (id) =>
    axios.post(`${API}/admin/submissions/${id}/revert`, {}, withAuth),
  adminDownloadDocx: (id) =>
    axios.get(`${API}/admin/submissions/${id}/docx`, { ...withAuth, responseType: "blob" }),
};
